import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { CollapsePanel } from 'Components/frameworks/collapse-panel/CollapsePanel';
import { Icon } from 'Components/frameworks/icon/Icon';
export type Service = {
  description?: string;
  icon: string;
  label: string;
};
export type Props = {
  className?: string;
  service: Service;
};
export const ProductService = ({ className, service }: Props): ReactNode => {
  const { description, icon, label } = service;
  return description ? (
    <CollapsePanel
      className={className}
      collapseIconName={ICONS.ARROW_DOWN}
      collapseLabel={t('common.included')}
      expandIconName={ICONS.ARROW_DOWN}
      expandLabel={t('common.included')}
      hasKeepCollapsedContent={false}
      iconName={icon}
      id={icon}
      isExpanded={false}
      key={icon}
      theme="remote"
      title={label}
    >
      <p className="px-15 pb-15 text-14">{description}</p>
    </CollapsePanel>
  ) : (
    <section
      className={classnames(
        'animation-duration-500 flex animate-fadeIn items-center justify-between gap-10 rounded-12 border-1 border-lightGrey bg-white p-15 shadow-diffuse',
        className,
      )}
    >
      <span className="flex flex-1 items-center gap-10 font-semibold">
        <Icon className="shrink-0 text-sienna" name={icon} width="1.875rem" />
        {label}
      </span>
      <span className="flex shrink-0 items-center whitespace-nowrap text-14 text-black">
        {t('common.included')}
      </span>
    </section>
  );
};
